import { tags } from "./resource";

export const getWorkspace = `
id
sk 
name 
idInc 
createdAt 
updatedAt
appKey 
workspaceId
`;

export const getWorkspaceUser = `
id
sk
name
isDisabled
`;

export const listUserWorkspaceFields = `
id
sk
name
schemaVersion
description
createdAt
updatedAt
lastActiveAt
acl
appLicenses {
  appId
  appKey
  isDisabled
  ${tags}
    app {
      id
      sk
      name
    }
}
isDisabled
roles {
  name
  description
  acl
}
${tags}
workspace {
  id
  sk
  name
  description
  acl
  type
  workspaceParentId
  ${tags}
}
`;

export const listUserWorkspaces = `
items {
  id
  sk
  name
  description
  createdAt
  updatedAt
  lastActiveAt
  acl
  isDisabled
  roles {
    name
    description
    acl
  }
  workspace {
    id
    sk
    name
    description
    acl
  }
}
nextToken
`;

export const getNextWorkspaceNumber = `
id
sk
counter
`;

export const getWorkspaceSubscription = `
id
sk
customerId
product {
  type
  name
  unitPrice
  units
  priceId
  updatedAt
}
billing {
  method {
    id
    type
    card {
      brand
      expMonth
      expYear
      last4
    }
    createdAt
  }
  contact {
    address1
    address2
    country
    city
    region
    postalCode
    phone
    email
  }
}
`;

export const listContentSharedToWorkspace = `
workspaceId
bankIds
workspace {
  id
  sk
  name
}
banks {
  id
  sk
  name
}
`;
